<div class="card text-bg-light" *ngIf="isLoading == true">
	<div class="card-body">
		Loading...
	</div>
</div>
<ng-container *ngIf="isLoading == false">
	<div *ngIf="data" [ngSwitch]="data.type" style="width: 100%; height: 100%">
		<app-dashboard-simple-count *ngSwitchCase="'SimpleCount'" [input]="asDashboardSimpleCountDto()"></app-dashboard-simple-count>
		<app-dashboard-line-graph *ngSwitchCase="'LineGraph'" [input]="asDashboardLineGraphDto()"></app-dashboard-line-graph>
		<app-dashboard-bar-chart *ngSwitchCase="'BarChart'" [input]="asDashboardBarChartDto()"></app-dashboard-bar-chart>
		<app-dashboard-pie-chart *ngSwitchCase="'PieChart'" [input]="asDashboardPieChartDto()"></app-dashboard-pie-chart>
		<app-dashboard-gauge *ngSwitchCase="'Gauge'" [input]="asDashboardGaugeDto()"></app-dashboard-gauge>
	</div>
	<div class="card text-bg-light" *ngIf="!data">
		<div class="card-body">
			<div class="h3 title small">
				<b>{{ defaultTitle }}</b>
			</div>
			No Data
		</div>
	</div>
</ng-container>
